



































import { FormQuestion, FormQuestionOptionsItem } from "@/store/modules/types";
import { Component, Prop, Watch, Model, Vue } from "vue-property-decorator";

@Component
export default class SingleChoiceAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  selected: FormQuestionOptionsItem | null = null;
  select(option: FormQuestionOptionsItem) {
    this.selected = option;
    this.$emit("answer", this.question.id, option.value, option.jumpToKey,option.updateGap,option.updateAppt);
  }
  mounted() {
    const { options, answer } = this.question;
    if (answer.value) {
      const option = options!.list.find((o) => o.value == answer.value);
      this.selected = option || null;
    }
  }
}
